import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { entitlementConfig } from 'entitlements';

export type NavData = NavSection[];
export type NavProfileData = NavSection[];
export type NavPlatformData = NavPlatformSection[];

export type NavSection = NavItem[];

export type NavItem = NavLink | NavMenu;

export type SubNavEvent = {
  type: string;
  customerId: string;
  id: string;
  path: string | undefined;
};

export type NavItemBase = entitlementConfig & {
  icon: IconDefinition;
  iconUrl?: string;
  tooltip?: string;
  // gainsightId?: string;
  badge?: string;
  disabled?: boolean;
};

export type SubNavItem = {
  id: string;
  text: string;
  path?: string;
  type: string;
  customerId: string;
  onClick?: (event: SubNavEvent) => void;
};

export type NavLink = NavItemBase & {
  text: string;
  path: string;
  newWindowOpen?: boolean;
  items?: SubNavItem[];
  showSubNav?: boolean;
};

export type SubNavLink = Omit<NavLink, 'icon'>;

export type NavMenu = NavItemBase & {
  title: string;
  items: SubNavLink[];
  showSubNav?: boolean;
};

export type NavPlatformSection = {
  title: string;
  items: NavItem[];
};

export function isNavItemLink(item: NavItem): item is NavLink {
  return 'path' in item;
}

export function isNavItemMenu(item: NavItem): item is NavMenu {
  return 'items' in item;
}
